import React, { useState, useEffect, useMemo } from 'react';
import { TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { useController, useForm, useWatch } from 'react-hook-form';
import { FooterButtons, TabsSelector } from '../NewGuestPassModal';
import Input from '../../../../../components/Forms/Input';


const providerTypes = [
  {key: 'shipping', name: "Paquetería"},
  {key: 'food', name: "Alimentos"},
  {key: 'other', name: "Otro"},
]

function DeliverySelector({onChange, selected}){

  return (
    <View style={tw`gap-x-4 gap-y-5`}>
      {
        providerTypes.map(provider =>
          <TouchableOpacity
            style={tw.style(`bg-white rounded-full px-5 py-5`, selected == provider.key && `bg-primary-800`)}
            onPress={() => onChange(provider)}
            key={provider.key}
          >
            <Text
              style={tw.style(`text-lg text-secondary font-600 text-center`, selected == provider.key && `text-white`)}
              >{provider.name}</Text>
          </TouchableOpacity>  
        )
      }
    </View>
  )
}


export default function DeliveryTypeStep({ control, name, setValue, onNextPressed, onBackPressed }) {
  const { field, fieldState: { invalid, isTouched, isDirty, error }, formState } = useController({
    control,
    name,
    rules: { required: true }
  })

  const providerTypeName = useWatch({
    control,
    name: "guest_name",
  })

  useEffect(() => {
    // if(field.value ==)
  }, [field.value]);

  return (
    <>
      <View style={tw`flex-1`}>
        <Text style={tw`text-white text-center text-xl font-500 mb-8`}>Describe tu proveedor</Text>

        <DeliverySelector
          onChange={provider => {
            field.onChange(provider.key)
            if(provider.key !== 'other'){
              setValue('guest_name', provider.name)
            }else{
              setValue('guest_name', null)
            }
          }}
          selected={field.value}
        />

        {
          field.value == "other" &&
            <View style={tw`mt-12`}>
              <Text style={tw`text-white text-center text-xl font-500 mb-6`}>Especifica tu entrega</Text>

              <Input
                control={control}
                name='guest_name'
                rules={{ required: true }}
                style={{ subcontainer: `bg-white`, container: tw`` }}
                // placeholder='Describe tu proveedor'
              />
            </View>
        }
      </View>

      <FooterButtons
        onBackPressed={onBackPressed}
        onNextPressed={onNextPressed}
        nextDisabled={!field.value || (field.value == "other" && !providerTypeName)}
      />
    </>
  )
}